"use client"; // This component must also be a Client Component

import React from "react";
import MoveTemok from "./MoveTemok"; // Adjust the path based on your structure
import HostVect from "../../../public/hostVect.png";

const MoveReusable = () => {
  const handleButtonClick = () => {
    console.log("Button clicked!");
  };
  
  return (
    <MoveTemok
      title="Move Forward with Temok.com"
      description="Our experts will move your website to Temok quickly and smoothly, ensuring everything works perfectly. Sit back while we handle the hard work."
      subtitle="Let our website-moving experts do all the heavy lifting."
      buttonText="Get Moving"
      imageSrc={HostVect}
      onButtonClick={handleButtonClick} // Passing the event handler
    />
  );
};

export default MoveReusable;
